<template>
    <div>
        <p>You need to be logged into your account to access the book materials.</p>
        <form @submit.prevent="signIn()">

            <div class="mb-3">
                <label for="sign-in-email" class="form-label fw-bold">Email</label>

                <input type="text" class="form-control" id="sign-in-email" v-model="loginData.email"
                    :class="{
                        'invalid' : errors && errors.email
                    }" required>
                <div class="invalid-feedback" v-if="errors && errors.password">{{errors.email}}</div>

            </div>
            <div class="mb-4">
                <label for="sign-in-password" class="form-label fw-bold">Password</label>

                <input type="password" class="form-control" id="sign-in-password" v-model="loginData.password"
                    :class="{
                        'invalid' : errors && errors.password
                    }" required>
                <div class="invalid-feedback" v-if="errors && errors.password">{{errors.password}}</div>

            </div>

            <div class="mb-3 text-center">
                <div class="col-12">
                    <button type="submit" class="btn dm-btn-padding">Log In</button>
                </div>
            </div>

            <div class="mb-3 text-center">
                <div class="col-12">
                    Don't have an account? <a href="" @click.prevent="$emit('showSignUpModal')" class="fw-bold text-decoration-underline">Register now!</a>
                </div>
            </div>

            <div>
                {{ errors }}
            </div>
        </form>
    </div>

</template>

<script>
export default {
	data() {
		return {
			loginData: {
				email: '',
				password: '',
			},
			errors: null,
		}
	},

	methods: {
		signIn() { 
			var self = this;

			axios.post('/login-popup', this.loginData)
				.then(function (response) {
					self.showConfirmationPopup();
				})
				.catch(error => {
					self.errors = error.response.data.errors
                    console.log(error)
                });
		},

		showConfirmationPopup() {
			this.$emit('closeAllModals');
			this.$swal({
				title: "You've successfuly logged into your account",
				text: "The page will reload and you will be able to access the materials available for this book",
				icon: "success",
				timer: 2500
			}).then(function () {
				location.reload();
			});
		},
	}
}
</script>
